/**
 * Brand configuration
 * Centralized branding information for white-label support
 */

const branding = {
  // App identity
  name: 'Expo Studio',
  shortName: 'Expo',
  tagline: 'Create. Present. Inspire.',

  // Company info
  company: 'UDXD',
  website: 'https://www.expostudio.co',
  supportEmail: 'support@expostudio.co',

  // App metadata (used in index.html, manifest.json)
  description: 'Expo Studio',
  themeColor: '#000000',
  backgroundColor: '#ffffff',

  // Help narrative IDs
  helpNarrativeId: 178,
  helpLargeTouchNarrativeId: 251,
  helpControllerNarrativeId: 252,
};

export default branding;
